export default __webpack_public_path__ + "static/media/explore.14ff6197.svg";